import React, {Component} from 'react';
import styles from './CitiesChips.module.css';

class CitiesChips extends Component{
    constructor(props){
        super(props);
        this.state = {
            selected: false
        }
        this._handleSelection = this._handleSelection.bind(this);
    }
    _handleSelection(){
        this.setState({
            selected: !this.state.selected
        })
    }
    render(){
        return(
            <div onClick={this._handleSelection} className={styles.container}>
                <div className={!this.state.selected ? styles.grey : styles.green}>
                    {this.props.data}
                </div>
            </div>
        )
    }
}

export default CitiesChips